import { Outlet } from "react-router";
import { PageBreadcrumb, Header } from "sj-ui-toolkit/src/atlas/components";
import { BreadcrumbProvider } from "sj-ui-toolkit/src/atlas/contexts";
import { UserContextProvider } from "sj-ui-toolkit/src/atlas/contexts/User/UserContextProvider";

import Sidepanel from "./Sidepanel";
import { themeClasses } from "sj-ui-toolkit/src/atlas/utils";

// ---------------------------------------------------------------------------
// Layout
// ---------------------------------------------------------------------------
// Atlas admin shell: fixed top nav + fixed sidepanel
// ---------------------------------------------------------------------------

export default function Layout() {
  return (
    <div data-testid="admin-layout" className="atlas-bg-home flex-layout">
      <UserContextProvider>
        <BreadcrumbProvider appRoot="admin">
          {/* Fixed top navigation */}
          <Header showBanner={false} className="print:hidden" />
          {/* Sidepanel — fixed left, below header */}
          <Sidepanel />
          <main id="main-content" className="ml-60 flex-main print:ml-0">
            <div className={themeClasses.mainContentContainer}>
              <PageBreadcrumb />
              <Outlet />
            </div>
          </main>
        </BreadcrumbProvider>
      </UserContextProvider>
    </div>
  );
}
